"use server";
import { ApiResponse } from "@/types/api";
import { cookies } from "next/headers";

export async function getOptCookie<T>(url:string): Promise<ApiResponse<T>>{
  const cookieStore = await cookies();
  const refresh = (await cookieStore.get("refreshT"))?.value;

  if(refresh && refresh !=""){
    return apiGet<T>(url)
  }

  const req = await fetch(process.env.NEXT_PRIVATE_API_URL + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (req.status == 401) return { success: false, error: "unauthorized" };
    if (!req.ok) return { success: false, error: req.status.toString() };

    return req.json();

}

export async function apiPost<T>(
  url: string,
  data: any,
): Promise<ApiResponse<T>> {
  const cookieStore = await cookies();
  const access = (await cookieStore.get("accessT"))?.value;
  if (!access) return { success: false, error: "unauthorized" };

  const req = await fetch(process.env.NEXT_PRIVATE_API_URL + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      body: JSON.stringify(data),
    });

    if (req.status == 401) return { success: false, error: "unauthorized" };
    if (!req.ok) return { success: false, error: req.status.toString() };

    return req.json();
}

export async function apiGet<T>(url: string): Promise<ApiResponse<T>> {
  const cookieStore = await cookies();
  const access = (await cookieStore.get("accessT"))?.value;
  if (!access) return { success: false, error: "unauthorized" };

  const req = await fetch(process.env.NEXT_PRIVATE_API_URL + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  });

  if (req.status == 401) return { success: false, error: "unauthorized" };

  if (!req.ok) return { success: false, error: req.status.toString() };

  return req.json();
}
